import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { useAuth } from '../App';

export default function Settings() {
  const { user } = useAuth();
  const [settings, setSettings] = useState({ company_name:'', session_timeout:'60' });
  const [pw, setPw] = useState({ current:'', next:'', confirm:'' });

  useEffect(() => { axios.get('/api/settings').then(r => setSettings(s=>({...s,...r.data}))).catch(()=>{}); }, []);

  const saveSettings = async () => {
    try { await axios.put('/api/settings', settings); toast.success('Αποθηκεύτηκε'); }
    catch { toast.error('Σφάλμα'); }
  };

  const changePw = async () => {
    if (pw.next !== pw.confirm) return toast.error('Οι κωδικοί δεν ταιριάζουν');
    if (pw.next.length < 8) return toast.error('Τουλάχιστον 8 χαρακτήρες');
    try {
      await axios.post('/api/auth/change-password', { current_password: pw.current, new_password: pw.next });
      toast.success('Ο κωδικός άλλαξε');
      setPw({ current:'', next:'', confirm:'' });
    } catch (err) { toast.error(err.response?.data?.error||'Σφάλμα'); }
  };

  const Section = ({ title, children }) => (
    <div className="card card-p" style={{ marginBottom:'16px' }}>
      <h3 style={{ fontSize:'13px', fontWeight:600, color:'var(--slate)', textTransform:'uppercase', letterSpacing:'0.05em', marginBottom:'16px' }}>{title}</h3>
      {children}
    </div>
  );

  return (
    <div style={{ maxWidth:'560px' }}>
      <div style={{ marginBottom:'24px' }}>
        <h1 style={{ fontSize:'22px', fontWeight:700, letterSpacing:'-0.03em' }}>Ρυθμίσεις</h1>
      </div>

      <Section title="Γενικά">
        <div className="form-group">
          <label className="form-label">Όνομα Εταιρείας</label>
          <input className="input" value={settings.company_name||''} onChange={e=>setSettings(s=>({...s,company_name:e.target.value}))} />
        </div>
        <div className="form-group">
          <label className="form-label">Session Timeout (λεπτά)</label>
          <input className="input" type="number" min="5" max="480" value={settings.session_timeout||'60'} onChange={e=>setSettings(s=>({...s,session_timeout:e.target.value}))} style={{ maxWidth:'120px' }} />
        </div>
        <button className="btn btn-primary btn-sm" onClick={saveSettings}>Αποθήκευση</button>
      </Section>

      <Section title="Αλλαγή Κωδικού">
        <p style={{ fontSize:'13px', color:'var(--slate)', marginBottom:'14px' }}>Λογαριασμός: <strong>{user.username}</strong></p>
        {[['current','Τρέχων κωδικός'],['next','Νέος κωδικός (min. 8 χαρακτήρες)'],['confirm','Επιβεβαίωση νέου κωδικού']].map(([k,l]) => (
          <div key={k} className="form-group">
            <label className="form-label">{l}</label>
            <input className="input" type="password" value={pw[k]} onChange={e=>setPw(p=>({...p,[k]:e.target.value}))} />
          </div>
        ))}
        <button className="btn btn-primary btn-sm" onClick={changePw}>Αλλαγή Κωδικού</button>
      </Section>

      <Section title="Πληροφορίες Συστήματος">
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'12px' }}>
          {[['Έκδοση','3.0.0'],['Stack','Node.js + React + MySQL'],['Email','Resend API'],['Hosting','Railway']].map(([k,v]) => (
            <div key={k} style={{ background:'var(--fog)', borderRadius:'8px', padding:'10px 14px' }}>
              <div style={{ fontSize:'11px', color:'var(--mist)', marginBottom:'3px' }}>{k}</div>
              <div style={{ fontSize:'13px', fontWeight:600 }}>{v}</div>
            </div>
          ))}
        </div>
      </Section>
    </div>
  );
}
